// extracted by mini-css-extract-plugin
module.exports = {"PospaidExtract":"PospaidExtract_PospaidExtract__3xTkR","content":"PospaidExtract_content__qvDMR","item":"PospaidExtract_item__3omrv","footer":"PospaidExtract_footer__9S2bC"};